import { useState } from "react";
import { useSEO } from "@/hooks/use-seo";
import { ArrowRight, Globe, Shield, AlertTriangle, ChevronDown, ChevronUp, CreditCard, Scale, HelpCircle, Trophy, CheckCircle, XCircle, Smartphone, Lock, BookOpen, Calendar, Award, Clock, Gamepad2, Headphones } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";

import logo1 from "@assets/logos_extracted/1.png";
import logo2 from "@assets/logos_extracted/2.png";
import logo3 from "@assets/logos_extracted/3.png";
import logo4 from "@assets/logos_extracted/4.png";
import logo5 from "@assets/logos_extracted/5.png";
import logo6 from "@assets/logos_extracted/6.png";
import logo7 from "@assets/logos_extracted/7.png";
import logo8 from "@assets/logos_extracted/8.png";
import logo9 from "@assets/logos_extracted/9.png";
import logo10 from "@assets/logos_extracted/10.png";
import logo11 from "@assets/logos_extracted/11.png";
import logo12 from "@assets/logos_extracted/12.png";
import logo13 from "@assets/logos_extracted/13.png";
import logo14 from "@assets/logos_extracted/14.png";
import logo15 from "@assets/logos_extracted/15.png";
import logo16 from "@assets/logos_extracted/16.png";
import logo17 from "@assets/logos_extracted/17.png";
import logo18 from "@assets/logos_extracted/18.png";
import logo19 from "@assets/logos_extracted/19.png";
import logo20 from "@assets/Untitled_design_(24)_1773076880991.png";

const CASINOS = [
  { name: "OnlySpins", logo: logo1, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://ons.lynmonkel.com/?mid=279656_1882080", reviewUrl: "/kasina/onlyspins" },
  { name: "Allyspin", logo: logo2, bonus: "až 25 000 Kč + 200 FS", licence: "Curaçao", url: "https://all.monvaki.com/?mid=282906_1667056", reviewUrl: "/kasina/allyspin" },
  { name: "Legiano", logo: logo3, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://lgno.monvaki.com/?mid=282906_1666929", reviewUrl: "/kasina/legiano" },
  { name: "Bassbet", logo: logo4, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://bsbt.fynkelto.com/?mid=279656_1645822", reviewUrl: "/kasina/bassbet" },
  { name: "FastSlots", logo: logo5, bonus: "až 125 000 Kč + 50 FS", licence: "Curaçao", url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM88TL4kmJ7MEGNd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/fastslots" },
  { name: "Spinanga", logo: logo6, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://spng.fynkelto.com/?mid=279656_1645837", reviewUrl: "/kasina/spinanga" },
  { name: "Rabona", logo: logo7, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://rbn.fynkelto.com/?mid=279656_1645828", reviewUrl: "/kasina/rabona" },
  { name: "Casinia", logo: logo8, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://csn.fynkelto.com/?mid=279656_1645832", reviewUrl: "/kasina/casinia" },
  { name: "Stone Vegas", logo: logo9, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://stnvgs.fynkelto.com/?mid=308616_1816138", reviewUrl: "/kasina/stone-vegas" },
  { name: "Golden Panda", logo: logo10, bonus: "až 125 000 Kč + 50 FS", licence: "Curaçao", url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM98YAuMxhPI-WNd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/golden-panda" },
  { name: "Instant Casino", logo: logo11, bonus: "až 185 000 Kč + 10% cashback", licence: "Curaçao", url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM-u11z-n_bVh2Nd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/instant-casino" },
  { name: "Boaboa", logo: logo12, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://bbaw.monvaki.com/?mid=282906_1667067", reviewUrl: "/kasina/boaboa" },
  { name: "Alf Casino", logo: logo13, bonus: "až 20 000 Kč + 300 FS", licence: "Curaçao", url: "https://alcw.monvaki.com/?mid=282906_1667062", reviewUrl: "/kasina/alf-casino" },
  { name: "Cadoola", logo: logo14, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://cadw.monvaki.com/?mid=282906_1667064", reviewUrl: "/kasina/cadoola" },
  { name: "Bankonbet", logo: logo15, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://bnkw.monvaki.com/?mid=282906_1667060", reviewUrl: "/kasina/bankonbet" },
  { name: "Wazamba", logo: logo16, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://wzbw.monvaki.com/?mid=282906_1667059", reviewUrl: "/kasina/wazamba" },
  { name: "SPINiT", logo: logo17, bonus: "až 12 500 Kč + 200 FS", licence: "MGA", url: "https://swp.fynkelto.com/?mid=279656_1645821", reviewUrl: "/kasina/spinit" },
  { name: "SG Casino", logo: logo18, bonus: "až 20 000 Kč + 250 FS", licence: "Curaçao", url: "https://sgc.monvaki.com/?mid=282906_1667053", reviewUrl: "/kasina/sg-casino" },
  { name: "Librabet", logo: logo19, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://lrb.fynkelto.com/?mid=279656_1645829", reviewUrl: "/kasina/librabet" },
  { name: "Nomini", logo: logo20, bonus: "až 12 500 Kč + 200 FS", licence: "Curaçao", url: "https://nmn.fynkelto.com/?mid=279656_1645825", reviewUrl: "/kasina/nomini" },
];

const FAQ = [
  {
    q: "Co je zahraniční online kasino?",
    a: "Zahraniční online kasino je platforma provozovaná na základě mezinárodní licence (např. MGA, Curaçao, Anjouan), která není vydána českým Ministerstvem financí. Tyto kasina nabízejí své služby hráčům z celého světa, včetně českých hráčů.",
  },
  {
    q: "Je legální hrát v zahraničním kasinu z Česka?",
    a: "Česká legislativa reguluje provozování hazardních her na území ČR, ale samotné hraní v zahraničních kasinech z pozice hráče není trestným činem. Je však důležité si uvědomit, že nemáte stejnou úroveň ochrany jako u kasin licencovaných českým MF.",
  },
  {
    q: "Jaké výhody mají zahraniční kasina oproti českým?",
    a: "Zahraniční kasina obvykle nabízejí širší výběr her, vyšší bonusy, podporu kryptoměn, nižší limity pro vklady a výběry a častější promo akce. Některá také umožňují anonymnější hraní bez nutnosti okamžité KYC verifikace.",
  },
  {
    q: "Jaká jsou rizika hraní v zahraničním kasinu?",
    a: "Mezi hlavní rizika patří omezená ochrana spotřebitele (nemůžete se obrátit na český regulační úřad), potenciálně delší doby výběrů, jazyková bariéra při řešení sporů a nutnost řešit případné problémy přes zahraniční regulátory.",
  },
  {
    q: "Jak poznám důvěryhodné zahraniční kasino?",
    a: "Hledejte kasina s platnou licencí od uznávaného regulátora (MGA, Curaçao eGaming), pozitivními recenzemi od hráčů, transparentními podmínkami, SSL šifrováním, širokou nabídkou platebních metod a profesionální zákaznickou podporou.",
  },
  {
    q: "Mohu v zahraničním kasinu platit v českých korunách?",
    a: "Většina zahraničních kasin primárně pracuje s EUR nebo USD, ale mnohá z nich umožňují vklady v CZK přes platební metody jako Skrill, Neteller nebo kryptoměny. Konverze měny je obvykle provedena automaticky.",
  },
  {
    q: "Jak funguje KYC verifikace v zahraničních kasinech?",
    a: "KYC (Know Your Customer) verifikace zahrnuje ověření identity předložením občanského průkazu, dokladu o adrese a případně potvrzení platební metody. V zahraničních kasinech je obvykle vyžadována při prvním výběru nebo při dosažení určitého objemu transakcí.",
  },
];

function FaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#eef1f7] last:border-0">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-4 text-left gap-4"
        data-testid={`faq-${q.slice(0, 20).replace(/\s/g, "-")}`}
      >
        <span className="font-semibold text-gray-900 text-sm">{q}</span>
        {open ? <ChevronUp className="w-4 h-4 text-[#003da5] flex-shrink-0" /> : <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0" />}
      </button>
      {open && <p className="text-gray-600 text-sm leading-relaxed pb-4">{a}</p>}
    </div>
  );
}

export default function ZahranicniPage() {
  useSEO({ title: "Zahraniční Online Kasina 2026 – Průvodce a recenze | HrajBonus", description: "Nejlepší zahraniční kasina pro české hráče. Výhody, rizika, výběr licencí a tipy expertů. Hrajte bezpečně v licencovaném kasinu. 18+",
  url: "https://hrajbonus.com/kasina/zahranicni", });

  return (
    <div className="min-h-screen bg-[#f5f7fb]">
      <Header />

      <section className="relative pt-16 pb-0 overflow-hidden">
        <div className="absolute inset-0 z-0" style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }} />
        <div className="absolute inset-0 z-0 opacity-5" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "40px 40px" }} />
        <div className="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-14 sm:py-16 text-center">
          <div className="flex flex-wrap items-center justify-center gap-3 mb-5">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-white/80 text-xs font-semibold uppercase tracking-widest">
              <Globe className="w-3.5 h-3.5 text-[#f5c518]" /> Průvodce zahraničními kasiny 2026
            </div>
            <div className="inline-flex items-center gap-1.5 bg-white/10 border border-white/20 rounded-full px-3 py-1.5 text-white/70 text-xs font-semibold" data-testid="badge-aktualizovano-zahranicni">
              <Calendar className="w-3 h-3" /> Aktualizováno: 12. března 2026
            </div>
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-white leading-tight mb-4" data-testid="heading-zahranicni">
            Zahraniční online kasina pro české hráče
          </h1>
          <p className="text-white/75 text-lg leading-relaxed max-w-2xl mx-auto mb-8">
            Kompletní průvodce zahraničními online kasiny — co nabízejí, jaké licence mají, pro koho se hodí a na co si dát pozor. Vše v češtině, nezávisle a bez příkras.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a href="#casino-list">
              <Button size="default" className="hraj-btn font-bold gap-2" style={{ background: "#ffffff", color: "#003da5" }} data-testid="button-hero-list">
                Zobrazit kasina <ArrowRight className="hraj-arrow w-4 h-4" />
              </Button>
            </a>
            <a href="#vyhody-rizika">
              <Button size="default" variant="outline" className="hraj-btn border-white/30 text-white font-semibold" style={{ background: "rgba(255,255,255,0.08)" }}>
                Výhody a rizika
              </Button>
            </a>
          </div>
        </div>
        <div className="relative z-10">
          <svg viewBox="0 0 1440 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full block" preserveAspectRatio="none" style={{ display: "block", verticalAlign: "bottom", height: "44px" }}>
            <rect x="0" y="40" width="1440" height="4" fill="#f5f7fb" />
            <path d="M0 44L1440 44L1440 0C1200 35 720 40 0 0L0 44Z" fill="#f5f7fb" />
          </svg>
        </div>
      </section>

        <CasinoBreadcrumb casinoName="Zahraniční kasina" />

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 space-y-10">

        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4" data-testid="heading-co-jsou">Co jsou zahraniční online kasina?</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Zahraniční online kasina jsou herní platformy, které fungují na základě mezinárodních licencí — nejčastěji od regulátorů jako Malta Gaming Authority (MGA), Curaçao eGaming nebo Anjouan Gaming Commission. Na rozdíl od kasin licencovaných českým Ministerstvem financí nejsou tato kasina přímo regulována českou legislativou, ale musí splňovat přísné požadavky svých licenčních úřadů.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Pro české hráče to znamená přístup k širšímu portfoliu her, často vyšším bonusům a alternativním platebním metodám včetně kryptoměn. Zahraniční kasina jsou oblíbená především mezi zkušenými hráči, kteří ocení rozmanitost nabídky a jsou ochotni akceptovat odlišný regulační rámec.
            </p>
            <div className="bg-[#f3f6fb] rounded-xl p-4">
              <div className="flex items-start gap-3">
                <Scale className="w-5 h-5 text-[#003da5] mt-0.5 flex-shrink-0" />
                <p className="text-gray-700 text-sm leading-relaxed">
                  <span className="font-bold">Důležité:</span> Zahraniční kasina nepodléhají české regulaci, což znamená, že případné spory se řeší prostřednictvím zahraničního regulátora. Vždy si ověřte platnost licence a důvěryhodnost kasina před registrací.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Pro koho jsou zahraniční kasina vhodná?</h2>
            <div className="grid sm:grid-cols-2 gap-6">
              <div>
                <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-green-600" /> Ideální pro
                </h3>
                <ul className="space-y-2">
                  {[
                    "Zkušené hráče, kteří rozumí rizikům a podmínkám",
                    "Hráče hledající větší výběr her a poskytovatelů",
                    "Uživatele kryptoměn, kteří chtějí platit Bitcoinem či Ethereem",
                    "Hráče preferující vyšší bonusy a častější promo akce",
                    "Ty, kteří hledají kasina s rychlými výběry přes e-peněženky",
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                      <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <XCircle className="w-4 h-4 text-red-500" /> Méně vhodná pro
                </h3>
                <ul className="space-y-2">
                  {[
                    "Úplné začátečníky bez zkušeností s online hazardem",
                    "Hráče, kteří vyžadují ochranu ze strany českého MF",
                    "Ty, kteří preferují výhradně českou zákaznickou podporu",
                    "Hráče s nízkým rozpočtem, kteří nemají zkušenosti s wagering podmínkami",
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                      <span className="text-red-400 font-bold mt-0.5 flex-shrink-0">−</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="vyhody-rizika">
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
              <h2 className="text-xl font-black text-gray-900 mb-4 flex items-center gap-2">
                <Trophy className="w-5 h-5 text-[#003da5]" /> Výhody zahraničních kasin
              </h2>
              <ul className="space-y-3">
                {[
                  { title: "Širší výběr her", desc: "Tisíce slotů, stolních her a live kasinových titulů od desítek poskytovatelů" },
                  { title: "Vyšší bonusy", desc: "Štědřejší uvítací balíčky, cashback programy a VIP odměny" },
                  { title: "Podpora kryptoměn", desc: "Bitcoin, Ethereum, Litecoin a další — rychlé a anonymní transakce" },
                  { title: "Rychlé výběry", desc: "Výběry přes e-peněženky a krypto často do 24 hodin" },
                  { title: "Inovativní funkce", desc: "Gamifikace, turnaje, achievement systémy a exkluzivní hry" },
                ].map(item => (
                  <li key={item.title} className="flex items-start gap-2">
                    <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <span className="font-semibold text-gray-900 text-sm">{item.title}</span>
                      <p className="text-gray-500 text-xs mt-0.5">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
              <h2 className="text-xl font-black text-gray-900 mb-4 flex items-center gap-2">
                <AlertTriangle className="w-5 h-5 text-amber-600" /> Rizika a na co si dát pozor
              </h2>
              <ul className="space-y-3">
                {[
                  { title: "Chybí česká regulace", desc: "Nemáte přímou ochranu od českého Ministerstva financí" },
                  { title: "Řešení sporů v zahraničí", desc: "V případě problému se musíte obrátit na zahraniční regulátora" },
                  { title: "KYC verifikace", desc: "Ověření identity může být zdlouhavější a vyžadovat překlad dokumentů" },
                  { title: "Měnové konverze", desc: "Některá kasina nepodporují CZK — pozor na konverzní poplatky" },
                  { title: "Podmínky bonusů", desc: "Čtěte vždy detailně wagering a výběrové limity před aktivací" },
                ].map(item => (
                  <li key={item.title} className="flex items-start gap-2">
                    <XCircle className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
                    <div>
                      <span className="font-semibold text-gray-900 text-sm">{item.title}</span>
                      <p className="text-gray-500 text-xs mt-0.5">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Licence a regulace zahraničních kasin</h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Licence je klíčovým ukazatelem důvěryhodnosti kasina. Každý licenční úřad má jiné požadavky a úroveň ochrany hráčů. Zde jsou nejčastější licence, se kterými se setkáte:
            </p>
            <div className="grid sm:grid-cols-3 gap-4">
              {[
                {
                  name: "Malta Gaming Authority (MGA)",
                  level: "Vysoká ochrana",
                  color: "text-green-700",
                  bg: "bg-green-50",
                  border: "border-green-200",
                  desc: "Nejprestižnější evropská licence. Přísná pravidla pro ochranu hráčů, povinné oddělené účty pro prostředky hráčů, pravidelné audity.",
                },
                {
                  name: "Curaçao eGaming",
                  level: "Střední ochrana",
                  color: "text-amber-700",
                  bg: "bg-amber-50",
                  border: "border-amber-200",
                  desc: "Nejrozšířenější licence pro mezinárodní kasina. Nižší náklady na provoz, méně přísná regulace, ale stále vyžaduje základní standardy bezpečnosti.",
                },
                {
                  name: "Anjouan Gaming",
                  level: "Základní ochrana",
                  color: "text-orange-700",
                  bg: "bg-orange-50",
                  border: "border-orange-200",
                  desc: "Novější licenční jurisdikce. Nižší požadavky na provozovatele, ale stále vyžaduje technické standardy a férovost her (RNG testování).",
                },
              ].map(lic => (
                <div key={lic.name} className={`${lic.bg} ${lic.border} border rounded-xl p-4`}>
                  <h3 className="font-bold text-gray-900 text-sm mb-1">{lic.name}</h3>
                  <span className={`text-xs font-semibold ${lic.color}`}>{lic.level}</span>
                  <p className="text-gray-600 text-xs mt-2 leading-relaxed">{lic.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4 flex items-center gap-2">
              <CreditCard className="w-5 h-5 text-[#003da5]" /> Platební metody v zahraničních kasinech
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Zahraniční kasina nabízejí širokou škálu platebních metod. Oproti českým licencovaným kasinům zde najdete navíc kryptoměny a některé alternativní e-peněženky.
            </p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { cat: "Platební karty", methods: "Visa, Mastercard, Maestro", note: "Nejrozšířenější, vklady okamžité" },
                { cat: "E-peněženky", methods: "Skrill, Neteller, MiFinity, ecoPayz", note: "Rychlé výběry (do 24 hod)" },
                { cat: "Kryptoměny", methods: "Bitcoin, Ethereum, Litecoin, Tether", note: "Anonymní, bez poplatků" },
                { cat: "Alternativní", methods: "Paysafecard, Neosurf, Apple Pay, Google Pay", note: "Vklady bez sdílení bankovních údajů" },
              ].map(pm => (
                <div key={pm.cat} className="bg-[#f3f6fb] rounded-xl p-4">
                  <h3 className="font-bold text-gray-900 text-sm mb-1">{pm.cat}</h3>
                  <p className="text-gray-700 text-xs mb-2">{pm.methods}</p>
                  <p className="text-gray-500 text-xs italic">{pm.note}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section data-testid="section-trust-zahranicni">
          <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-2xl p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-2 flex items-center gap-2">
              <Award className="w-6 h-6 text-[#003da5]" /> Proč tyto kasina doporučujeme
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-5">
              Každé kasino v našem seznamu prochází důkladnou redakční kontrolou. Doporučujeme pouze platformy, které splňují naše přísné standardy ve čtyřech klíčových oblastech:
            </p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { icon: Shield, title: "Ověřená licence", desc: "Platná licence od uznávaného regulátora (MGA, Curaçao eGaming) je základní podmínkou pro zařazení." },
                { icon: Clock, title: "Rychlost výplat", desc: "Testujeme reálné doby výběrů — doporučujeme kasina s výplatami do 24–48 hodin." },
                { icon: Gamepad2, title: "Nabídka her", desc: "Minimálně 1 000+ her od renomovaných poskytovatelů jako NetEnt, Pragmatic Play nebo Evolution." },
                { icon: Headphones, title: "Zákaznická podpora", desc: "Dostupný live chat, rychlé reakce a profesionální řešení problémů hráčů." },
              ].map(({ icon: Icon, title, desc }) => (
                <div key={title} className="bg-white rounded-xl p-4 border border-[#dde4ee]">
                  <Icon className="w-8 h-8 text-[#003da5] mb-3" />
                  <div className="font-bold text-gray-900 text-sm mb-1">{title}</div>
                  <p className="text-gray-600 text-xs leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="casino-list">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-black text-gray-900 mb-2" data-testid="heading-casino-list">Zahraniční kasina pro české hráče</h2>
            <p className="text-gray-500 text-base">Kasina s mezinárodní licencí, ověřená naší redakcí</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {CASINOS.map((casino, i) => (
              <div
                key={casino.name}
                className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden hover:shadow-md transition-shadow"
                data-testid={`zahranicni-casino-${i}`}
              >
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0">
                      <img src={casino.logo} alt={casino.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="min-w-0">
                      <div className="font-black text-gray-900 text-sm truncate">{casino.name}</div>
                      <div className="flex items-center gap-1 text-xs text-gray-500">
                        <Shield className="w-3 h-3" /> {casino.licence}
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-lg px-3 py-2 mb-3">
                    <span className="text-[#003da5] font-bold text-sm">{casino.bonus}</span>
                  </div>
                  <div className="flex gap-2">
                    <a href={casino.url} target="_blank" rel="sponsored noopener noreferrer" className="flex-1">
                      <Button size="sm" className="hraj-btn w-full font-bold gap-1.5 text-white" style={{ background: "#003da5" }} data-testid={`button-zahranicni-hraj-${i}`}>
                        Hrát <ArrowRight className="hraj-arrow w-3.5 h-3.5" />
                      </Button>
                    </a>
                    <a href={casino.reviewUrl}>
                      <Button size="sm" variant="outline" className="hraj-btn-light font-semibold text-[#003da5]" data-testid={`button-zahranicni-review-${i}`}>
                        <BookOpen className="w-3.5 h-3.5" />
                      </Button>
                    </a>
                  </div>
                </div>
                <div className="px-5 py-2 bg-[#f3f5f9] border-t border-[#dde4ee] flex items-center gap-1.5">
                  <Lock className="w-3 h-3 text-gray-500" />
                  <span className="text-[11px] text-gray-500 font-semibold">18+ | Hrajte zodpovědně</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section>
          <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 shadow-sm">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-6 h-6 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <h2 className="text-xl font-black text-gray-900 mb-2">Zodpovědné hraní</h2>
                <p className="text-gray-700 text-sm leading-relaxed mb-3">
                  Hazardní hry jsou formou zábavy, nikoliv cestou k výdělku. Při hraní v zahraničních kasinech platí stejná pravidla zodpovědného hraní jako kdekoli jinde:
                </p>
                <ul className="space-y-1.5 text-gray-700 text-sm">
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Nastavte si denní, týdenní nebo měsíční limity pro vklady a prohry
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Nikdy nehrajte s penězi, které si nemůžete dovolit prohrát
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Využívejte nástroje pro sebeomezení, které kasina nabízejí
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Pokud cítíte, že máte problém s hraním, obraťte se na organizace jako{" "}
                    <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="text-[#003da5] hover:underline font-semibold" data-testid="link-gamcare-zahranicni">GamCare</a>{" "}
                    nebo{" "}
                    <a href="https://www.gamblingtherapy.org/" target="_blank" rel="noopener noreferrer" className="text-[#003da5] hover:underline font-semibold" data-testid="link-gambling-therapy">Gambling Therapy</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="faq">
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <div className="flex items-center gap-2 mb-4">
              <HelpCircle className="w-5 h-5 text-[#003da5]" />
              <h2 className="text-2xl font-black text-gray-900" data-testid="heading-faq">Časté dotazy o zahraničních kasinech</h2>
            </div>
            {FAQ.map(item => (
              <FaqItem key={item.q} q={item.q} a={item.a} />
            ))}
          </div>
        </section>

      </div>

      <Footer />
    </div>
  );
}